import io from 'socket.io-client'
import { communication, homeData, blog } from './store'

const SOCKET_ADDRESS = window.location.protocol + '//' + window.location.hostname + ':' + (process.env.NODE_ENV === 'production' ? '443' : '55522')

const HOME_DATA_REQUEST = 'homeDataRequest'
const BLOG_DATA_REQUEST = 'blogDataRequest'

let socket

export const connectToServer = async () => {
    socket = io(SOCKET_ADDRESS + '/io-public', { secure: process.env.NODE_ENV === 'production' })
    socket.on('connect', (socket) => {
    })
}

export const homeDataRequest = () => {
    if (socket) {
        communication.isInProgress = true
        socket.emit(HOME_DATA_REQUEST, {},
            (error, response) => {
                communication.isInProgress = false
                if (error) console.log(error)
                else homeData.data = response
            })
    }
}

export const getBlogRequest = () => {
    if (socket) {
        communication.isInProgress = true
        socket.emit(BLOG_DATA_REQUEST, { quantity: 4 },
            (error, response) => {
                communication.isInProgress = false
                if (error) console.log(error)
                else blog.posts = response
            })
    }
}


// WEBPACK FOOTER //
// ./src/modules/communication.js